/*! WiZM JS v1.0.1 | wizm.io | (c) 2026 */
/*! Build: https://cdn.wizm.io/js/v1.0.1/wizm.min.js */
;(function (window) {
  "use strict";

  // Global WiZM namespace + Config Container
  var WiZM = window.WiZM || {};
  WiZM.config = WiZM.config || {};

  window.WiZM = WiZM;
})(window);

;(function ($, window, document) {
  "use strict";

  // Toggle Config Getter
  function getToggleConfig() {
    var defaults = {
      slideSpeed: 300 // ms
    };

    if (window.WiZM && WiZM.config && WiZM.config.toggle) {
      var overrides = WiZM.config.toggle;
      if (overrides && typeof overrides === "object") {
        return Object.assign({}, defaults, overrides);
      }
    }

    return defaults;
  }

  // Toggle Class ON/OFF
  window.wzOnOff = function (el) {
    var $el = $(el);
    if ($el.length) {
      $el.toggleClass("wz--on wz--off");
    }
  };

  // Toggle Class OPEN/CLOSE
  window.wzOpenClose = function (el) {
    var $el = $(el);
    if ($el.length) {
      $el.toggleClass("wz--open wz--close");
    }
  };

  // Toggle Class SHOW/HIDE
  window.wzShowHide = function (el) {
    var $el = $(el);
    if ($el.length) {
      $el.toggleClass("wz--show wz--hide");
    }
  };

  // Slide Toggle Function
  window.wzSlideToggle = function (el, speed) {
    var cfg = getToggleConfig();
    var $el = $(el);

    if (!$el.length) return;

    var duration = typeof speed === "number" ? speed : cfg.slideSpeed;
    $el.stop(true, true).slideToggle(duration);
  };

  // Toggle Visibility Between Two Elements
  window.wzSwitch = function (el1, el2) {
    var $e1 = $(el1);
    var $e2 = $(el2);

    if ($e1.length) {
      $e1.toggleClass("wz--show wz--hide");
    }
    if ($e2.length) {
      $e2.toggleClass("wz--show wz--hide");
    }
  };

})(jQuery, window, document);

;(function ($, window, document) {
  "use strict";

  // Button Config Getter
  function getButtonConfig() {
    var defaults = {
      selectors: {
        loaderTrigger: ".wz--loader-btn"
      },
      classes: {
        disabled: "wz--disabled",
        spinner: "wz--animate wz--spin"
      },
      spinnerHtml: "<i class=\"fas fa-spinner\"></i>"
    };

    if (window.WiZM && WiZM.config && WiZM.config.buttons) {
      var overrides = WiZM.config.buttons;
      if (overrides && typeof overrides === "object") {
        var merged = Object.assign({}, defaults, overrides);

        if (overrides.selectors) {
          merged.selectors = Object.assign({}, defaults.selectors, overrides.selectors);
        }
        if (overrides.classes) {
          merged.classes = Object.assign({}, defaults.classes, overrides.classes);
        }

        return merged;
      }
    }

    return defaults;
  }

  // --------------------------------------------------
  // Enable Button
  // --------------------------------------------------
  window.wzButtonEnable = function (btn) {
    var cfg  = getButtonConfig();
    var $btn = $(btn);

    $btn
      .removeClass(cfg.classes.disabled)
      .removeAttr("disabled");
  };

  // --------------------------------------------------
  // Disable Button
  // --------------------------------------------------
  window.wzButtonDisable = function (btn) {
    var cfg  = getButtonConfig();
    var $btn = $(btn);

    $btn
      .addClass(cfg.classes.disabled)
      .attr("disabled", "disabled");
  };

  // --------------------------------------------------
  // Loader Button (Auto-Enable on Click)
  // --------------------------------------------------
  $(document).on("click.wzLoaderBtn", function (e) {
    var cfg = getButtonConfig();
    var $target = $(e.target).closest(cfg.selectors.loaderTrigger);

    if ($target.length) {
      window.wzLoaderBtn($target);
    }
  });

  // --------------------------------------------------
  // Start Button Loader
  // --------------------------------------------------
  window.wzLoaderBtn = function (btn) {
    var cfg  = getButtonConfig();
    var $btn = $(btn);

    if ($btn.data("wz-loading") === true) {
      return; // Prevent double-trigger
    }

    var prevHtml = $btn.html();

    $btn
      .data("wz-prev-html", prevHtml)
      .data("wz-loading", true)
      .attr("disabled", "disabled")
      .addClass(cfg.classes.disabled)
      .html(cfg.spinnerHtml)
      .find("i")
      .addClass(cfg.classes.spinner);
  };

  // --------------------------------------------------
  // Stop Button Loader (Restore Previous Content)
  // --------------------------------------------------
  window.wzLoaderBtnStop = function (btn) {
    var cfg  = getButtonConfig();
    var $btn = $(btn);

    var previousHtml = $btn.data("wz-prev-html");
    if (previousHtml !== undefined) {
      $btn.html(previousHtml);
      $btn.removeData("wz-prev-html");
    }

    $btn
      .removeData("wz-loading")
      .removeAttr("disabled")
      .removeClass(cfg.classes.disabled);
  };

})(jQuery, window, document);

;(function ($, window, document) {
  "use strict";

  window.WiZM = window.WiZM || {};
  window.WiZM.fn = window.WiZM.fn || {};

  // Loader Config Getter
  function getLoaderConfig() {
    var defaults = {
      fadeDuration: 300,
      selectors: {
        loader: ".wz-loader",
        windowCover: ".wz-window-cover"
      },
      bodyClasses: {
        loading: "wz--loading",
        noScroll: "wz--no-scroll"
      }
    };

    if (window.WiZM && WiZM.config && WiZM.config.loader) {
      var overrides = WiZM.config.loader;
      if (overrides && typeof overrides === "object") {
        var merged = Object.assign({}, defaults, overrides);

        if (overrides.selectors && typeof overrides.selectors === "object") {
          merged.selectors = Object.assign({}, defaults.selectors, overrides.selectors);
        }
        if (overrides.bodyClasses && typeof overrides.bodyClasses === "object") {
          merged.bodyClasses = Object.assign({}, defaults.bodyClasses, overrides.bodyClasses);
        }

        return merged;
      }
    }

    return defaults;
  }

  // Inner Loader Show Function
  window.wzInnerLoaderShow = function (target) {
    var $target = $(target);
    if (!$target.length) return;

    if ($target.find(".wz-loader-inner").length === 0) {
      $target.append("<div class=\"wz-loader-inner\"><span></span></div>");
    }
  };

  // Inner Loader Hide Function
  window.wzInnerLoaderHide = function (target) {
    if (target) {
      $(target).find(".wz-loader-inner").remove();
    } else {
      // IMPORTANT: Do NOT remove the inner loader inside the main window loader
      var cfg = getLoaderConfig();
      var $mainLoader = $(cfg.selectors.loader);
      var $protected = $mainLoader.length ? $mainLoader.find(".wz-loader-inner") : $();

      if ($protected.length) {
        $(".wz-loader-inner").not($protected).remove();
      } else {
        $(".wz-loader-inner").remove();
      }
    }
  };

  // Window Cover Show Function
  window.wzWindowCoverShow = function (el) {
    var cfg = getLoaderConfig();
    var $cover = $(cfg.selectors.windowCover);

    if ($cover.length === 0) {
      if (el) {
        $(el).after("<div class=\"wz-window-cover\"></div>");
      } else {
        $("body").append("<div class=\"wz-window-cover\"></div>");
      }
      $cover = $(cfg.selectors.windowCover);
    }

    $cover.stop(true, true).fadeIn(cfg.fadeDuration);
  };

  // Window Cover Hide Function
  window.wzWindowCoverHide = function (el) {
    var cfg = getLoaderConfig();
    var $cover = $(cfg.selectors.windowCover);

    if ($cover.length) {
      $cover.stop(true, true).fadeOut(cfg.fadeDuration, function () {
        $(this).remove();
      });
    }

    if (el) {
      $(el).removeClass("wz--open").addClass("wz--close");
    }
  };

  // Window Loader Show Function
  window.wzWindowLoader = function () {
    var cfg = getLoaderConfig();
    var $loader = $(cfg.selectors.loader);

    if ($loader.length) {
      $loader.stop(true, true).fadeIn(cfg.fadeDuration);
    }
    $("body").addClass(cfg.bodyClasses.loading);
  };

  // Window Loader Close Function
  window.wzWindowLoaderClose = function () {
    var cfg = getLoaderConfig();
    var $loader = $(cfg.selectors.loader);

    if ($loader.length) {
      $loader.stop(true, true).fadeOut(cfg.fadeDuration);
    }
    $("body").removeClass(cfg.bodyClasses.loading);
  };

  // Window Loader Click Handler
  $(document).off("click.wzLoader").on("click.wzLoader", ".wz--load", function () {
    window.wzWindowLoader();
  });

  // Reset Loader State
  function wzResetLoaderState() {
    var cfg = getLoaderConfig();

    window.wzWindowLoaderClose();

    // IMPORTANT: Only remove inner loaders NOT inside the main loader
    var $mainLoader = $(cfg.selectors.loader);
    var $protected = $mainLoader.length ? $mainLoader.find(".wz-loader-inner") : $();

    if ($protected.length) {
      $(".wz-loader-inner").not($protected).remove();
    } else {
      $(".wz-loader-inner").remove();
    }

    $(cfg.selectors.windowCover).remove();
    $("body").removeClass(cfg.bodyClasses.loading).removeClass(cfg.bodyClasses.noScroll);
  }

  // Reset On Page Show (BFCache)
  $(window).off("pageshow.wzLoader").on("pageshow.wzLoader", function () {
    wzResetLoaderState();
  });

  window.wzResetLoaderState = wzResetLoaderState;

  // Namespace Mirror
  window.WiZM.fn.loader = {
    show: window.wzWindowLoader,
    hide: window.wzWindowLoaderClose,
    reset: window.wzResetLoaderState,
    coverShow: window.wzWindowCoverShow,
    coverHide: window.wzWindowCoverHide,
    innerShow: window.wzInnerLoaderShow,
    innerHide: window.wzInnerLoaderHide
  };

})(jQuery, window, document);

;(function ($, window, document) {
  "use strict";

  window.WiZM = window.WiZM || {};
  window.WiZM.fn = window.WiZM.fn || {};

  // Toast Config Getter
  function getToastConfig() {
    var defaults = {
      duration: 5000, // ms
      fadeSpeed: 200, // ms
      aria: {
        enabled: true
      }
    };

    if (window.WiZM && WiZM.config && WiZM.config.toast) {
      var overrides = WiZM.config.toast;
      if (overrides && typeof overrides === "object") {
        var merged = Object.assign({}, defaults, overrides);
        if (overrides.aria && typeof overrides.aria === "object") {
          merged.aria = Object.assign({}, defaults.aria, overrides.aria);
        }
        return merged;
      }
    }

    return defaults;
  }

  // Toast Notification Function
  window.wzToast = function (type, display, message, icon) {
    var cfg = getToastConfig();

    var colorClass = "wz--notice";
    if (type === 2) colorClass = "wz--success";
    else if (type === 3) colorClass = "wz--warning";
    else if (type === 4) colorClass = "wz--error";

    var positionClass = "wz--b wz--fadeInUp";
    if (display === 1) positionClass = "wz--t wz--fadeInDown";
    else if (display === 3) positionClass = "wz--t wz--center wz--fadeInDown";
    else if (display === 4) positionClass = "wz--b wz--center wz--fadeInUp";

    icon = icon || "";
    message = message || "";

    // Accessibility
    var role = "status";
    var ariaLive = "polite";
    if (type === 4) { // error
      role = "alert";
      ariaLive = "assertive";
    }

    var ariaAttrs = "";
    if (cfg.aria && cfg.aria.enabled === true) {
      ariaAttrs = " role=\"" + role + "\" aria-live=\"" + ariaLive + "\" aria-atomic=\"true\"";
    }

    var toastHtml =
      "<div class=\"wz-toast wz--animate " + colorClass + " " + positionClass + "\"" + ariaAttrs + ">" +
        "<i class=\"wz-toast-icon " + icon + "\"></i>" +
        "<div class=\"wz-toast-content\">" +
          "<p class=\"wz-text wz--size-1 wz--text-600\">" + message + "</p>" +
        "</div>" +
      "</div>";

    var $toast = $(toastHtml).appendTo("body");

    $toast
      .stop(true, true)
      .fadeIn(cfg.fadeSpeed)
      .delay(cfg.duration)
      .fadeOut(cfg.fadeSpeed, function () {
        $(this).remove();
      });
  };

  // Auto-Hide Existing Toasts (Server-Rendered)
  $(function () {
    var cfg = getToastConfig();
    var $existing = $(".wz-toast");

    if (!$existing.length) return;

    $existing.each(function () {
      $(this)
        .stop(true, true)
        .delay(cfg.duration)
        .fadeOut(cfg.fadeSpeed, function () {
          $(this).remove();
        });
    });
  });

  // Namespace Mirror
  window.WiZM.fn.toast = window.wzToast;

})(jQuery, window, document);

// SETTINGS
// --- Set Open Trigger Class Name     = class="wz-js-trigger-modal-open"
// --- Set Open Trigger Data Attribute = data-modal="wz-modal-name"
// --- Set Close Trigger Class Name    = class="wz-js-trigger-modal-close"
/*

<button class="wz-js-trigger-modal-open" data-modal="modal-example">Open</button>

<div class="wz-modal wz-modal-example">
  <div class="wz-modal-content">
    <button class="wz-js-trigger-modal-close">X</button>
    Modal Content Here
  </div>
</div>

*/

;(function ($, window, document) {
  "use strict";

  window.WiZM = window.WiZM || {};
  window.WiZM.fn = window.WiZM.fn || {};

  // Modal Config Getter
  function getModalConfig() {
    var defaults = {
      fadeDuration: 300, // ms

      // Accessibility
      a11y: {
        enabled: true,
        role: "dialog",
        ariaModal: true,
        focusOnOpen: true,
        restoreFocusOnClose: true,
        closeOnEsc: true
      },

      // Image Modal Defaults (Optional Feature)
      imageTriggerSelector: ".wz-js-modal-image",
      imageSelectorInModal: "img",
      imageSrcDataAttr: "src"
    };

    if (window.WiZM && WiZM.config && WiZM.config.modal) {
      var overrides = WiZM.config.modal;
      if (overrides && typeof overrides === "object") {
        var merged = Object.assign({}, defaults, overrides);
        if (overrides.a11y && typeof overrides.a11y === "object") {
          merged.a11y = Object.assign({}, defaults.a11y, overrides.a11y);
        }
        return merged;
      }
    }

    return defaults;
  }

  // Modal Selectors
  var OPEN_TRIGGER = ".wz-js-trigger-modal-open";
  var CLOSE_TRIGGER = ".wz-js-trigger-modal-close";

  // Track Last Trigger For Focus Restore
  var lastTriggerEl = null;

  // Find First Focusable Element
  function getFirstFocusable($modal) {
    var $focusables = $modal.find("a, button, input, select, textarea, [tabindex]:not([tabindex=\"-1\"])").filter(":visible");
    return $focusables.length ? $focusables.first() : $();
  }

  // Apply A11y Attributes
  function applyA11y($modal, cfg) {
    if (!cfg.a11y || cfg.a11y.enabled !== true) return;

    $modal.attr("role", cfg.a11y.role || "dialog");
    $modal.attr("aria-hidden", "false");

    if (cfg.a11y.ariaModal === true) {
      $modal.attr("aria-modal", "true");
    }
  }

  // Clear A11y Attributes
  function clearA11y($modal, cfg) {
    if (!cfg.a11y || cfg.a11y.enabled !== true) return;

    $modal.attr("aria-hidden", "true");
  }

  // Set Modal Image Source From Trigger
  function setModalImageFromTrigger($trigger, cfg, $modal) {
    if (!$trigger || $trigger.length === 0) return;

    var dataAttr = cfg.imageSrcDataAttr || "src";
    var src = $trigger.attr("data-" + dataAttr) || $trigger.data(dataAttr) || "";

    if (!src) {
      var $img = $trigger.is("img") ? $trigger : $trigger.find("img").first();
      src = $img.attr("src") || "";
    }

    if (!src) return;

    var $targetImg = $modal.find(".wz-modal-content " + cfg.imageSelectorInModal).first();
    if ($targetImg.length === 0) {
      $targetImg = $modal.find(cfg.imageSelectorInModal).first();
    }

    if ($targetImg.length) {
      $targetImg.attr("src", src);
    }
  }

  // Close Helper
  function closeModal($modal) {
    var cfg = getModalConfig();
    if (!$modal || !$modal.length) return;

    $modal.fadeOut(cfg.fadeDuration, function () {
      clearA11y($modal, cfg);

      // Restore focus
      if (cfg.a11y && cfg.a11y.enabled === true && cfg.a11y.restoreFocusOnClose === true && lastTriggerEl) {
        try { lastTriggerEl.focus(); } catch (e) {}
        lastTriggerEl = null;
      }
    });
  }

  // Open Modal
  $(document).off("click.wzModalOpen").on("click.wzModalOpen", OPEN_TRIGGER, function (e) {
    e.stopPropagation();

    var cfg = getModalConfig();
    lastTriggerEl = this;

    var modalName = $(this).data("modal");
    var $modal = modalName ? $(".wz-" + modalName) : $();

    if ($modal.length === 0) return;

    // Optional Image Support
    if ($(this).is(cfg.imageTriggerSelector) || $(this).closest(cfg.imageTriggerSelector).length) {
      setModalImageFromTrigger($(this), cfg, $modal);
    }

    applyA11y($modal, cfg);

    $modal.fadeIn(cfg.fadeDuration, function () {
      if (cfg.a11y && cfg.a11y.enabled === true && cfg.a11y.focusOnOpen === true) {
        var $focus = getFirstFocusable($modal);
        if ($focus.length) {
          try { $focus.focus(); } catch (err) {}
        }
      }
    });
  });

  // Prevent Closing When Clicking Inside Modal Content
  $(document).off("click.wzModalContent").on("click.wzModalContent", ".wz-modal-content", function (e) {
    e.stopPropagation();
  });

  // Close On Backdrop Click
  $(document).off("click.wzModalBackdrop").on("click.wzModalBackdrop", ".wz-modal", function () {
    closeModal($(this));
  });

  // Close Via Close Trigger
  $(document).off("click.wzModalClose").on("click.wzModalClose", CLOSE_TRIGGER, function (e) {
    e.stopPropagation();
    closeModal($(this).closest(".wz-modal"));
  });

  // Close On ESC
  $(document).off("keydown.wzModalEsc").on("keydown.wzModalEsc", function (e) {
    var cfg = getModalConfig();
    if (!cfg.a11y || cfg.a11y.enabled !== true || cfg.a11y.closeOnEsc !== true) return;

    if (e.key === "Escape") {
      var $open = $(".wz-modal:visible").first();
      if ($open.length) closeModal($open);
    }
  });

  // Namespace Mirror
  window.WiZM.fn.modal = {
    openSelector: OPEN_TRIGGER,
    closeSelector: CLOSE_TRIGGER
  };

})(jQuery, window, document);

// SETTINGS
// --- Set Form Element Data Attribute = data-loader="true"

;(function ($, window, document) {
  "use strict";

  // Form Config Getter
  function getFormConfig() {
    var defaults = {
      // Phone Formatting
      phone: {
        enabled: true,
        selectorDefault: ".wz-js-phone",
        selectorDash: ".wz-js-phone-dash",
        formatDefault: "(xxx) xxx-xxxx",
        formatDash: "xxx-xxx-xxxx",
        maxDigits: 10
      },

      // Dynamic Field Repeater
      repeater: {
        enabled: true,

        // Triggers
        addTrigger: ".wz-js-trigger-link-add",
        removeTrigger: ".wz-js-trigger-link-remove",

        // Containers
        itemSelector: ".wz-form-container-link",
        listSelector: ".wz-form-container-links",

        // Behavior
        maxItems: 0,             // 0 = unlimited
        preventRemoveLast: false, // True = keep at least one item

        // UI
        addButtonText: "",        // Optional: update the add trigger text
        removeButtonHtml: "<button type=\"button\" class=\"wz-js-trigger-link-remove\">Remove</button>",

        // Clear Rules
        clearInputs: true,
        clearTextareas: true,
        resetSelects: true,
        clearCheckboxes: true,
        clearRadios: true
      }
    };

    if (window.WiZM && WiZM.config && WiZM.config.form) {
      var overrides = WiZM.config.form;
      if (overrides && typeof overrides === "object") {
        var merged = Object.assign({}, defaults, overrides);

        // Merge Nested Config
        if (overrides.phone && typeof overrides.phone === "object") {
          merged.phone = Object.assign({}, defaults.phone, overrides.phone);
        }
        if (overrides.repeater && typeof overrides.repeater === "object") {
          merged.repeater = Object.assign({}, defaults.repeater, overrides.repeater);
        }

        return merged;
      }
    }

    return defaults;
  }

  // Form Submit Loader Handler
  $(document).on("submit.wzFormLoader", ".wz-js-form", function () {
    var $form = $(this);
    var loader = $form.data("loader");

    if (!loader) {
      return; // No loader option set, just submit normally
    }

    // Prefer Explicit Submit Button, Fallback To First Button
    var $button = $form.find("button[type=\"submit\"]").first();
    if ($button.length === 0) {
      $button = $form.find("button").first();
    }

    // Apply Button Loader (If Available)
    if ($button.length && typeof window.wzLoaderBtn === "function") {
      window.wzLoaderBtn($button);
    }

    // Show Global Window Loader (If Available)
    if (typeof window.wzWindowLoader === "function") {
      window.wzWindowLoader();
    }

    // Do Not Prevent Default – Form Should Still Submit Normally
  });

  // Phone Format Plugin (Define Once)
  function ensurePhonePlugin() {
    if ($.fn.usPhoneFormat) {
      return;
    }

    // US Phone Formatter Plugin
    $.fn.usPhoneFormat = function (options) {
      var settings = $.extend(
        {
          format: "(xxx) xxx-xxxx",
          maxDigits: 10
        },
        options
      );

      // Format Phone Digits Using Mask
      function formatPhone(digits, mask) {
        var formatted = "";
        var di = 0;

        for (var i = 0; i < mask.length && di < digits.length; i++) {
          if (mask.charAt(i) === "x") {
            formatted += digits.charAt(di++);
          } else {
            formatted += mask.charAt(i);
          }
        }

        return formatted;
      }

      return this.each(function () {
        var $input = $(this);

        // Make It Clear To Mobile Browsers This Is A Phone Field
        $input.attr("inputmode", "tel");

        // Clamp Maxlength To The Mask Length
        $input.attr("maxlength", String(settings.format).length);

        // Normalize Input Value
        function normalize() {
          var raw = $input.val() || "";
          var digits = String(raw).replace(/\D/g, "");

          if (settings.maxDigits && digits.length > settings.maxDigits) {
            digits = digits.slice(0, settings.maxDigits);
          }

          $input.val(formatPhone(digits, settings.format));
        }

        // Normalize Pre-Filled Value On Load
        normalize();

        // Use Input Event So We Catch Typing, Paste, Autocomplete, Etc.
        $input.off("input.usPhoneFormat").on("input.usPhoneFormat", normalize);
      });
    };
  }

  // Init Phone Formatting
  function initPhoneFormatting(cfg) {
    var phoneCfg = cfg.phone;

    if (!phoneCfg || phoneCfg.enabled !== true) {
      return;
    }

    ensurePhonePlugin();

    // Default: (xxx) xxx-xxxx
    var $default = $(phoneCfg.selectorDefault);
    if ($default.length) {
      $default.usPhoneFormat({
        format: phoneCfg.formatDefault,
        maxDigits: phoneCfg.maxDigits
      });
    }

    // Alternate: xxx-xxx-xxxx
    var $dash = $(phoneCfg.selectorDash);
    if ($dash.length) {
      $dash.usPhoneFormat({
        format: phoneCfg.formatDash,
        maxDigits: phoneCfg.maxDigits
      });
    }
  }

  // Repeater: Clear Cloned Fields
  function clearRepeaterFields($root, rep) {
    if (rep.clearInputs) {
      $root.find("input").each(function () {
        var $input = $(this);
        var type = String($input.attr("type") || "").toLowerCase();

        if (type === "checkbox") {
          if (rep.clearCheckboxes) $input.prop("checked", false);
          return;
        }

        if (type === "radio") {
          if (rep.clearRadios) $input.prop("checked", false);
          return;
        }

        $input.val("");
      });
    }

    if (rep.clearTextareas) {
      $root.find("textarea").val("");
    }

    if (rep.resetSelects) {
      $root.find("select").prop("selectedIndex", 0);
    }
  }

  // Init Dynamic Repeater
  function initRepeater(cfg) {
    var rep = cfg.repeater;

    if (!rep || rep.enabled !== true) {
      return;
    }

    // Optional: Update Add Button Text
    if (rep.addButtonText) {
      $(rep.addTrigger).text(rep.addButtonText);
    }

    // Add Item
    $(document).off("click.wzRepeaterAdd").on("click.wzRepeaterAdd", rep.addTrigger, function (e) {
      e.preventDefault();

      var $list = $(rep.listSelector).first();
      if ($list.length === 0) return;

      var $template = $(rep.itemSelector).first();
      if ($template.length === 0) return;

      // Enforce Max Items (0 = Unlimited)
      if (rep.maxItems && rep.maxItems > 0) {
        var count = $list.find(rep.itemSelector).length;
        if (count >= rep.maxItems) {
          return;
        }
      }

      var $clone = $template.clone();

      // Clear Values
      clearRepeaterFields($clone, rep);

      // Append Remove Button (If Not Already Present)
      if (rep.removeButtonHtml) {
        if ($clone.find(rep.removeTrigger).length === 0) {
          $clone.append(rep.removeButtonHtml);
        }
      }

      // Insert Before The Add Trigger Button
      $(this).before($clone);
    });

    // Remove Item
    $(document).off("click.wzRepeaterRemove").on("click.wzRepeaterRemove", rep.removeTrigger, function (e) {
      e.preventDefault();

      var $item = $(this).closest(rep.itemSelector);
      if ($item.length === 0) return;

      if (rep.preventRemoveLast === true) {
        var $list = $item.closest(rep.listSelector);
        if ($list.length) {
          var count = $list.find(rep.itemSelector).length;
          if (count <= 1) {
            return;
          }
        }
      }

      $item.remove();
    });
  }

  // Initialize
  $(function () {
    var cfg = getFormConfig();
    initPhoneFormatting(cfg);
    initRepeater(cfg);
  });

  // Form Dirty State Handler
  $(function () {

    const formSelector = '.wz-js-form-dirty';
    const disabledClass = 'wz--disabled';
    let hasDirtyForm = false;

    function getFormState($form) {
      const data = [];

      $form.find(':input[name]').each(function () {
        const $field = $(this);
        const type = ($field.attr('type') || '').toLowerCase();
        const tag = this.tagName.toLowerCase();
        const name = $field.attr('name');

        if ($field.is(':disabled')) {
          return;
        }

        if (type === 'checkbox' || type === 'radio') {
          data.push({
            name: name,
            value: $field.val(),
            checked: $field.is(':checked')
          });
        } else if (tag === 'select' && $field.prop('multiple')) {
          data.push({
            name: name,
            value: $field.val() || []
          });
        } else {
          data.push({
            name: name,
            value: $field.val()
          });
        }
      });

      return JSON.stringify(data);
    }

    function setFormButtonState($form, isDirty) {
      const $buttons = $form.find('[type="submit"]');

      $buttons.prop('disabled', !isDirty);

      if (isDirty) {
        $buttons.removeClass(disabledClass);
      } else {
        $buttons.addClass(disabledClass);
      }
    }

    function refreshDirtyState() {
      hasDirtyForm = false;

      $(formSelector).each(function () {
        if ($(this).data('dirty') === true) {
          hasDirtyForm = true;
          return false;
        }
      });
    }

    $(formSelector).each(function () {
      const $form = $(this);
      const initialState = getFormState($form);

      $form.data('initial-state', initialState);
      $form.data('dirty', false);

      setFormButtonState($form, false);
    });

    $(document).on('input change', `${formSelector} :input[name]`, function () {
      const $form = $(this).closest(formSelector);
      const initialState = $form.data('initial-state');
      const currentState = getFormState($form);
      const isDirty = currentState !== initialState;

      $form.data('dirty', isDirty);
      setFormButtonState($form, isDirty);
      refreshDirtyState();
    });

    $(document).on('submit', formSelector, function () {
      const $form = $(this);

      $form.data('initial-state', getFormState($form));
      $form.data('dirty', false);
      setFormButtonState($form, false);
      refreshDirtyState();
    });

    $(window).on('beforeunload', function (e) {
      if (!hasDirtyForm) {
        return;
      }

      e.preventDefault();
      e.returnValue = '';
      return '';
    });

  });

  $(function () {
    $(document).on('click', '.wz-js-image-upload', function (e) {
      if ($(e.target).hasClass('wz-js-image-input')) {
        return;
      }

      $(this).find('.wz-js-image-input').trigger('click');
    });

    $(document).on('keydown', '.wz-js-image-upload', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).find('.wz-js-image-input').trigger('click');
      }
    });

    $(document).on('change', '.wz-js-image-input', function () {
      const input = this;
      const $input = $(input);
      const $parent = $input.closest('.wz-js-image-upload');
      const $preview = $parent.find('.wz-js-image-preview').first();

      if (!input.files || !input.files.length) {
        return;
      }

      const file = input.files[0];

      if (!file.type.match(/^image\//)) {
        input.value = '';
        return;
      }

      const reader = new FileReader();

      reader.onload = function (e) {
        $preview.attr('src', e.target.result);
        $parent.removeClass('wz--empty');
      };

      reader.readAsDataURL(file);

      $input.trigger('input');
    });

  });

})(jQuery, window, document);

;(function ($, window, document) {
  "use strict";

  window.WiZM = window.WiZM || {};
  window.WiZM.fn = window.WiZM.fn || {};

  // Scroll Config Getter
  function getScrollConfig() {
    var defaults = {
      // Scroll Animate (Legacy)
      animatePercentDefault: 0.2,   // 20% of viewport

      // Back To Top
      backToTopThreshold: 100,      // px scrolled before showing button

      // Anchor Scroll
      anchorScrollDuration: 750,    // ms
      fixedNavOffsetAdjust: 1,      // px adjust from nav height

      // Intersection Effects
      effects: {
        enabled: true,
        selectors: ".wz--scrollFadeLeft, .wz--scrollFadeRight, .wz--scrollFadeUp, .wz--scrollFadeDown, .wz--scrollFadeIn, .wz--scrollBounce",
        threshold: 0.3,             // 30% of element is visible
        visibleClass: "wz--is-visible",
        unobserveOnReveal: false    // Set true to prevent re-animation on scroll up
      },

      // Performance
      optimizeScroll: true,         // rAF-throttle scroll work

      // Shared Selectors
      selectors: {
        backToTop: "#backToTop",
        footer: "#footer",
        fixedNav: ".wz-nav.wz--fixed",
        recaptchaBadge: ".grecaptcha-badge" // Set to "" or null to disable
      }
    };

    if (window.WiZM && WiZM.config && WiZM.config.scroll) {
      var overrides = WiZM.config.scroll;
      if (overrides && typeof overrides === "object") {
        var merged = Object.assign({}, defaults, overrides);

        // Merge nested objects safely
        if (overrides.selectors && typeof overrides.selectors === "object") {
          merged.selectors = Object.assign({}, defaults.selectors, overrides.selectors);
        }
        if (overrides.effects && typeof overrides.effects === "object") {
          merged.effects = Object.assign({}, defaults.effects, overrides.effects);
        }

        return merged;
      }
    }

    return defaults;
  }

  // --------------------------------------------------
  // Scroll To Fixed
  // --------------------------------------------------
  window.wzScrollFixed = function (el, parent, offset) {
    offset = typeof offset === "number" ? offset : 0;

    var $el = $(el);
    var $parent = $(parent);

    if ($el.length === 0 || $parent.length === 0) return;

    var scrollTop = window.pageYOffset || $(window).scrollTop();
    var parentTop = $parent.offset().top - offset;
    var parentHeight = $parent.outerHeight(true);
    var parentBottom = parentTop + parentHeight;

    var elHeight = $el.outerHeight(true);
    var windowHeight = window.innerHeight || $(window).height();

    // Only apply fixed behavior if parent is tall enough
    if (parentHeight <= (elHeight * 2)) {
      $el.removeClass("wz--fixed wz--bottom");
      return;
    }

    // Fixed in middle section
    if (scrollTop >= parentTop && (scrollTop + windowHeight) < parentBottom) {
      $el.addClass("wz--fixed").removeClass("wz--bottom");
      return;
    }

    // Locked to bottom of parent
    if (scrollTop + windowHeight >= parentBottom) {
      $el.addClass("wz--bottom").removeClass("wz--fixed");
      return;
    }

    // Above parent
    $el.removeClass("wz--fixed wz--bottom");
  };

  // --------------------------------------------------
  // Scroll Animate (Legacy)
  // --------------------------------------------------
  window.wzScrollAnimate = function (target, percent, removeClass) {
    var cfg = getScrollConfig();

    target = target || ".wz-js-scrollAnimate";
    percent = typeof percent === "number" ? percent : cfg.animatePercentDefault;
    removeClass = removeClass || null;

    var $targets = $(target);
    if ($targets.length === 0) return;

    // Hide targets initially
    $targets.css({ opacity: 0, visibility: "hidden" });

    function revealVisible() {
      var windowHeight = window.innerHeight || $(window).height();
      var viewportBottom = (window.pageYOffset || $(window).scrollTop()) + windowHeight;
      var offset = percent * windowHeight;

      $targets.each(function () {
        var $el = $(this);
        var top = $el.offset().top;

        if (top <= (viewportBottom - offset)) {
          if (removeClass !== null) {
            $el.removeClass(removeClass);
          } else {
            $el.css({ opacity: 1, visibility: "visible" });
          }
        }
      });
    }

    // Namespaced + rAF-throttled scroll (optional)
    var ticking = false;
    function onScroll() {
      if (cfg.optimizeScroll !== true) {
        revealVisible();
        return;
      }
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        revealVisible();
        ticking = false;
      });
    }

    $(window).off("scroll.wzScrollAnimate").on("scroll.wzScrollAnimate", onScroll);
    revealVisible(); // Run once on load
  };

  // --------------------------------------------------
  // Back To Top Scroll Handler
  // --------------------------------------------------
  function handleBackToTopScroll() {
    var cfg = getScrollConfig();
    var $backToTop = $(cfg.selectors.backToTop);

    if ($backToTop.length === 0) return;

    var scrollTop = window.pageYOffset || $(window).scrollTop();
    var windowHeight = window.innerHeight || $(window).height();
    var docHeight = $(document).height();

    var $footer = $(cfg.selectors.footer);
    var badgeSelector = cfg.selectors.recaptchaBadge;
    var $badge = badgeSelector ? $(badgeSelector) : $();

    // Show/hide button
    if (scrollTop >= cfg.backToTopThreshold) {
      $backToTop.removeClass("wz--hide");
    } else {
      $backToTop.addClass("wz--hide");
    }

    // Lock near footer
    if ($footer.length) {
      var footerHeight = $footer.outerHeight() || 0;
      if (scrollTop + windowHeight > (docHeight - footerHeight)) {
        $backToTop.addClass("wz--locked");
        if ($badge.length) $badge.addClass("wz--locked");
      } else {
        $backToTop.removeClass("wz--locked");
        if ($badge.length) $badge.removeClass("wz--locked");
      }
    }
  }

  // --------------------------------------------------
  // Column Fade-In / Bounce Effects (IntersectionObserver)
  // --------------------------------------------------
  function initScrollEffects() {
    var cfg = getScrollConfig();
    var effectsCfg = cfg.effects;

    if (!effectsCfg || effectsCfg.enabled !== true) return;

    var selector = String(effectsCfg.selectors || "").trim();
    if (!selector) return;

    if (!("IntersectionObserver" in window)) return;

    var els = document.querySelectorAll(selector);
    if (!els || els.length === 0) return;

    var visibleClass = effectsCfg.visibleClass || "wz--is-visible";
    var threshold = typeof effectsCfg.threshold === "number" ? effectsCfg.threshold : 0.3;
    var unobserveOnReveal = effectsCfg.unobserveOnReveal === true;

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (entry && entry.isIntersecting) {
          entry.target.classList.add(visibleClass);
          if (unobserveOnReveal) observer.unobserve(entry.target);
        }
      }
    }, { threshold: threshold });

    for (var j = 0; j < els.length; j++) {
      observer.observe(els[j]);
    }
  }

  // --------------------------------------------------
  // Click Scroll (Smooth Anchor Scroll)
  // --------------------------------------------------
  window.clickScroll = function (anchor, offset) {
    var cfg = getScrollConfig();
    var diff = typeof offset === "number" ? offset : 0;

    if (
      location.pathname.replace(/^\//, "") === anchor.pathname.replace(/^\//, "") &&
      location.hostname === anchor.hostname
    ) {
      var $target = $(anchor.hash);
      $target = $target.length ? $target : $("[name=\"" + anchor.hash.slice(1) + "\"]");

      if ($target.length) {
        $("html, body").animate(
          { scrollTop: $target.offset().top - diff },
          cfg.anchorScrollDuration
        );
        return false;
      }
    }
  };

  // --------------------------------------------------
  // Init
  // --------------------------------------------------
  $(function () {
    var cfg = getScrollConfig();

    // Legacy scroll-animate
    window.wzScrollAnimate();

    // Intersection effects
    initScrollEffects();

    // Back-to-top scroll with rAF throttle (optional)
    var ticking = false;
    function backToTopOnScroll() {
      if (cfg.optimizeScroll !== true) {
        handleBackToTopScroll();
        return;
      }
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        handleBackToTopScroll();
        ticking = false;
      });
    }

    $(window).off("scroll.wzBackToTop").on("scroll.wzBackToTop", backToTopOnScroll);
    handleBackToTopScroll();

    // Fixed nav offset
    var navHeight = 0;
    var $fixedNav = $(cfg.selectors.fixedNav).first();
    if ($fixedNav.length) {
      navHeight = (($fixedNav.outerHeight() || 0) - cfg.fixedNavOffsetAdjust);
    }

    // Global anchor click to smooth scroll
    $(document).off("click.wzAnchorScroll").on("click.wzAnchorScroll", "a[href*=\"#\"]:not([href=\"#\"])", function (e) {
      var handled = window.clickScroll(this, navHeight);
      if (handled === false) e.preventDefault();
    });
  });

  // Namespace Mirror
  window.WiZM.fn.scroll = {
    animate: window.wzScrollAnimate,
    fixed: window.wzScrollFixed,
    clickScroll: window.clickScroll
  };

})(jQuery, window, document);

;(function ($, window, document) {
  "use strict";

  // Slide Config Getter
  function getSlideConfig() {
    var defaults = {
      selectors: {
        toggleTrigger: ".wz-slide-toggle-trigger",
        toggleGroup: ".wz-slide-toggle-group",
        menu: ".wz-slide-menu",
        menuTrigger: ".wz-slide-menu-trigger",
        menuClose: ".wz-slide-menu-close",
        windowCover: ".wz-window-cover"
      }
    };

    if (window.WiZM && WiZM.config && WiZM.config.slide) {
      var overrides = WiZM.config.slide;
      if (overrides && typeof overrides === "object") {
        var merged = Object.assign({}, defaults, overrides);

        // Merge nested objects safely
        if (overrides.selectors && typeof overrides.selectors === "object") {
          merged.selectors = Object.assign({}, defaults.selectors, overrides.selectors);
        }

        return merged;
      }
    }

    return defaults;
  }

  // Slide Toggle Trigger Click Handler
  $(document).on("click", ".wz-slide-toggle-trigger", function (event) {
    event.preventDefault();

    var cfg = getSlideConfig();
    var $trigger = $(this);
    var $group = $trigger.next(cfg.selectors.toggleGroup);

    if ($group.length && typeof window.wzSlideToggle === "function") {
      window.wzSlideToggle($group);
    }
  });

  // Slide Menu Open Handler
  $(document).on("click", ".wz-slide-menu-trigger", function (event) {
    event.preventDefault();

    var cfg = getSlideConfig();
    var $menu = $(cfg.selectors.menu).first();
    if ($menu.length === 0) return;

    if (typeof window.wzOpenClose === "function") {
      window.wzOpenClose($menu);
    }
    if (typeof window.wzWindowCoverShow === "function") {
      window.wzWindowCoverShow($menu);
    }
  });

  // Window Cover Click Handler (Closes Slide Menu)
  $(document).on("click", ".wz-window-cover", function (event) {
    event.preventDefault();

    var cfg = getSlideConfig();
    var $menu = $(cfg.selectors.menu).first();

    if (typeof window.wzWindowCoverHide !== "function") return;

    // If slide menu exists, pass it so it also flips open/close classes
    if ($menu.length) {
      window.wzWindowCoverHide($menu);
      return;
    }

    // Fallback: hide cover even if slide menu is not present
    window.wzWindowCoverHide();
  });

  // Slide Menu Close Button Handler
  $(document).on("click", ".wz-slide-menu-close", function (event) {
    event.preventDefault();

    var cfg = getSlideConfig();
    var $menu = $(cfg.selectors.menu).first();

    if ($menu.length && typeof window.wzOpenClose === "function") {
      window.wzOpenClose($menu);
    }
    if (typeof window.wzWindowCoverHide === "function") {
      window.wzWindowCoverHide();
    }
  });

})(jQuery, window, document);

;(function ($, window, document) {
  "use strict";

  // --------------------------------------------------
  // Autocomplete Config Getter
  // --------------------------------------------------
  function getAutocompleteConfig() {
    var defaults = {
      // Selectors
      inputSelector: ".wz-js-autocomplete-input",
      resultsSelector: ".wz-js-autocomplete-results",

      // jQuery UI Options
      minLength: 1,
      source: "",
      position: { my: "left top", at: "left bottom" },
      messages: {
        noResults: "Sorry, there are no results matching your search query.",
        results: ""
      },

      // Navigation (Default Uses item.link)
      navigate: function (item) {
        if (item && item.link) {
          window.location.href = item.link;
        }
      },

      // Item Normalizer
      normalizeItem: function (item) {
        item = item || {};
        return {
          link: item.link || "#",
          image: item.image || "",
          title: item.title || "",
          details: item.details || "",
          raw: item
        };
      },

      // Render Actions HTML
      renderActions: function () {
        return "";
      },

      // Render Item HTML
      renderItem: function (normalized, actionsHtml) {
        actionsHtml = actionsHtml || "";

        return (
          "<div class=\"wz-js-autocomplete-item wz--load\">" +
            "<div class=\"wz-js-autocomplete-item_image wz-image-parent wz--image-sml\">" +
              "<img src=\"" + normalized.image + "\" alt=\"\">" +
            "</div>" +
            "<div class=\"wz-js-autocomplete-item_label\">" +
              "<div class=\"wz-js-autocomplete-item_label-inner\">" +
                "<h3>" + normalized.title + "</h3>" +
                "<p>" + normalized.details + "</p>" +
              "</div>" +
            "</div>" +
            actionsHtml +
          "</div>"
        );
      },

      // Wrapper <li> class
      listItemClass: "wz-li"
    };

    if (window.WiZM && WiZM.config && WiZM.config.autocomplete) {
      var overrides = WiZM.config.autocomplete;
      if (overrides && typeof overrides === "object") {
        var merged = Object.assign({}, defaults, overrides);
        return merged;
      }
    }

    return defaults;
  }

  // --------------------------------------------------
  // Autocomplete Input Focus Behavior
  // --------------------------------------------------
  function wzAutocompleteFocus($input) {
    if (!$input || $input.length === 0) return;

    var originalValue = $input.data("val");

    // Clear field on focus
    $input.val("");

    // Restore original value if left empty on blur
    $input.off("blur.wzAutocompleteFocus").one("blur.wzAutocompleteFocus", function () {
      var current = $(this).val();
      if (!current || String(current).trim().length === 0) {
        $(this).val(originalValue);
      }
    });
  }

  // --------------------------------------------------
  // Initialize Autocomplete Events
  // --------------------------------------------------
  function initAutocompleteEvents() {
    var cfg = getAutocompleteConfig();

    $(document)
      .off("focus.wzAutocomplete click.wzAutocomplete", cfg.inputSelector)
      .on("focus.wzAutocomplete click.wzAutocomplete", cfg.inputSelector, function () {
        wzAutocompleteFocus($(this));
      });
  }

  // --------------------------------------------------
  // Initialize jQuery UI Autocomplete
  // --------------------------------------------------
  function initAutocompletePlugin() {
    // Ensure jQuery UI Autocomplete is available
    if (typeof $.fn.autocomplete !== "function") {
      return;
    }

    var cfg = getAutocompleteConfig();
    var $inputs = $(cfg.inputSelector);

    if ($inputs.length === 0) {
      return;
    }

    // Determine append target; fallback to body
    var $appendTo = $(cfg.resultsSelector);
    if ($appendTo.length === 0) {
      $appendTo = $("body");
    }

    $inputs.each(function () {
      var $input = $(this);

      // Prevent double-init (important when projects re-run init logic)
      if ($input.data("wz-autocomplete-init") === true) {
        return;
      }
      $input.data("wz-autocomplete-init", true);

      var ac = $input.autocomplete({
        appendTo: $appendTo,
        minLength: cfg.minLength,
        position: cfg.position,
        source: cfg.source,
        messages: cfg.messages,
        select: function (event, ui) {
          if (ui && ui.item && typeof cfg.navigate === "function") {
            cfg.navigate(ui.item);
          }
          return false;
        }
      });

      var instance = ac.autocomplete("instance");
      if (!instance) return;

      instance._renderItem = function (ul, item) {
        // Normalize item
        var normalized = (typeof cfg.normalizeItem === "function")
          ? cfg.normalizeItem(item)
          : (item || {});

        // Render actions
        var actionsHtml = (typeof cfg.renderActions === "function")
          ? cfg.renderActions(normalized)
          : "";

        // Render full item HTML
        var html = (typeof cfg.renderItem === "function")
          ? cfg.renderItem(normalized, actionsHtml)
          : "";

        return $("<li class=\"" + cfg.listItemClass + "\">")
          .append(html)
          .appendTo(ul);
      };
    });
  }

  // --------------------------------------------------
  // Initialization
  // --------------------------------------------------
  $(function () {
    initAutocompleteEvents();
    initAutocompletePlugin();
  });

  // --------------------------------------------------
  // Expose Public API
  // --------------------------------------------------
  window.wzAutocompleteFocus = wzAutocompleteFocus;

})(jQuery, window, document);

;(function (window, document) {
  "use strict";

  // Video Config Getter
  function getVideoConfig() {
    var defaults = {
      enabled: true,

      // Target Video Element
      targetId: "heroVideo",

      // Intersection Observer
      useIntersectionObserver: true,
      threshold: 0.25,

      // Behavior
      autoPlay: true,
      muteIfNeeded: true,        // Helps autoplay on mobile browsers
      setPlaysInlineIfNeeded: true
    };

    if (window.WiZM && WiZM.config && WiZM.config.video) {
      var overrides = WiZM.config.video;
      if (overrides && typeof overrides === "object") {
        return Object.assign({}, defaults, overrides);
      }
    }

    return defaults;
  }

  // Load <source data-src="..."> Into <source src="...">
  function hydrateSources(videoEl) {
    var sources = videoEl.querySelectorAll("source");
    if (!sources || sources.length === 0) {
      return;
    }

    for (var i = 0; i < sources.length; i++) {
      var s = sources[i];
      if (s && s.dataset && s.dataset.src) {
        s.src = s.dataset.src;
        delete s.dataset.src;
      }
    }
  }

  // Try To Play Video (Autoplay-Friendly)
  function tryPlay(videoEl, cfg) {
    if (!cfg.autoPlay) {
      return;
    }

    if (cfg.setPlaysInlineIfNeeded) {
      // iOS Safari: playsinline improves autoplay/inline behavior
      if (!videoEl.hasAttribute("playsinline")) {
        videoEl.setAttribute("playsinline", "");
      }
      if (!videoEl.hasAttribute("webkit-playsinline")) {
        videoEl.setAttribute("webkit-playsinline", "");
      }
    }

    if (cfg.muteIfNeeded) {
      // Most browsers require muted for autoplay
      videoEl.muted = true;
      videoEl.setAttribute("muted", "");
    }

    var playPromise = videoEl.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {
        // Autoplay can fail due to browser policies; fail silently
      });
    }
  }

  // Load And Optionally Play
  function loadAndMaybePlay(videoEl, cfg) {
    hydrateSources(videoEl);
    videoEl.load();
    tryPlay(videoEl, cfg);
  }

  // Init Hero Video Lazy Load
  function initHeroVideo() {
    var cfg = getVideoConfig();
    if (!cfg.enabled) {
      return;
    }

    var videoEl = document.getElementById(cfg.targetId);
    if (!videoEl) {
      return;
    }

    // If IntersectionObserver is unavailable or disabled, load immediately
    if (!cfg.useIntersectionObserver || !("IntersectionObserver" in window)) {
      loadAndMaybePlay(videoEl, cfg);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i] && entries[i].isIntersecting) {
            loadAndMaybePlay(videoEl, cfg);
            io.disconnect();
            break;
          }
        }
      },
      { threshold: cfg.threshold }
    );

    io.observe(videoEl);
  }

  // Init On Ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeroVideo);
  } else {
    initHeroVideo();
  }

})(window, document);
